export const USER_FILTER_LIST = [
  {
    label: 'Autohuissalland verkoper',
    value: 1,
  },
];

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE = [
  'economic_prize',
  'financial_purchase_price_marge_bpm',
  'financial_purchase_price_marge_excl_bpm',
  'rest_bpm',
  'taxiVerleden',
  'financial_bpm_gross',
];

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW = [
  'financial_purchase_price_incl_vat_bpm',
  'economic_prize',
  'rest_bpm',
  'taxiVerleden',
  'financial_purchase_price_incl_vat_excl_bpm',
  'financial_purchase_price_incl_bpm_excl_btw',
  'vat_percentage',
  'vat_amount',
  'financial_purchase_price_excl_vat_excl_bpm',
  'financial_bpm_gross',
];

export const VEHICLE_DETAILS_VEHICLE_DATA_CARD = [
  'vin',
  'regplate',
  'mileage',
  'vehicle_purpose',
  'new_from_factory',
  'import',
  'ex_rental',
  'damaged',
  'is_taxi',
  'date_apk_expiry',
  'wegenbelasting',
  'date_first_allowance',
  'rDWDatumEersteToelatingNationaal',
  'fuel_type',
  'transmission_type',
  'body_type',
  'base_color',
  'secondary_color',
  'battery_capacity',
  // 'stadagen',
  'power',
  'power_axle',
  'date_expected',
  'nedcCo2Emission',
  'wltpCo2Emission',
  'euro_class',
];

export const VEHICLE_DETAILS_SALESCARD = [
  'financial_price_b2c',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'outgoing_rest_bpm',
  'rest_bpm_export',
  'catalogprice_incl_options',
  //'delivery_costs',
];

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2 = [
  'status',
  'transmission_type',
  'fuel_type',
  'power',
  'battery_capacity',
  'vehicle_purpose',
  'tax_type',
  'rest_bpm',
  'financial_bpm_gross',
  'financial_price_b2c',
  'nedcCo2Emission',
  'wltpCo2Emission',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'incoming_invoice_in_helga',
  'outgoing_invoice_in_helga',
  'economic_prize',
  'outgoing_rest_bpm',
  'incoming_rest_bpm',
];

export const BUYERS_OPTIONS = [
  {
    label: 'Teun in de Wal',
    value: 1,
  },
  {
    label: 'Gebruiker 2',
    value: 2,
  },
];
